// extracted by mini-css-extract-plugin
export default {"form-control":"Input_form-control__s8vUh","label":"Input_label__jZHIi","input":"Input_input__bYwse","icon":"Input_icon__tCns5"};